export default "__VITE_ASSET__312679eb__"